exports.products = {
  "products":[
    {"name" : "Tetley Tea 250 bags","qty":40,"purchase_price":1.00,"sale_price":2.40,"barcode":"1234"},
    {"name" : "Sugar 1kg","qty":20,"purchase_price":0.50,"sale_price":1.20,"barcode":"1234567"},
    {"name" : "Milk 4 pint","qty":14,"purchase_price":0.75,"sale_price":1.05,"barcode":"12344567"}
    ]
}